import { render, staticRenderFns } from "./SuperAdminComponent.vue?vue&type=template&id=012f8776&"
import script from "./SuperAdminComponent.vue?vue&type=script&lang=js&"
export * from "./SuperAdminComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports